import { combineReducers } from 'redux';
import authSlice from './features/authSlice';
import modalSlice from './features/modalSlice';
import filterSlice from './features/filterSlice';

const rootReducer = combineReducers({
  auth: authSlice,
  modal: modalSlice,
  filter: filterSlice,
});

export default rootReducer;
